import ApiInstance from './instance'
import AuthApi from './auth.api'
import UserApi from './user.api'
import ChainApi from './chain.api'
import FacilityApi from './facility.api'
import ImportApi from './import.api'
import ResidentApi from './resident.api'
import StatisticsApi from './statistics.api'
import StatementApi from './statement.api'
import CommentApi from './comments.api'
import PermissionsApi from './permissions.api'
import TemplateApi from './template.api'
import CollectionFlowApi from './collectionFlow.api'
import ClaimFlowApi from './claimFlow.api'
import TransactionsApi from './transactions.api'
import PaymentsApi from './payments.api'
import { getSearchOptions } from '@/utils/helpers'
import ResidentPortalApi from '@/api/residentPortal.api'
import HmoApi from '@/api/hmo.api'
import LetterApi from '@/api/letter.api'
import TodoApi from '@/api/todo.api'
import UtilsApi from '@/api/utils.api'
import BillingApi from './billing.api'
import OnboardingApi from './onboarding.api'
import TrainingApi from './training.api'
import UserHolidayPopupApi from './user.holiday.popup.api'
import EligibilityTaskApi from '@/api/eligibilityTask.api'
import V2Api from './v2.api'

class Api {
  private instance: ApiInstance
  public auth: AuthApi
  public user: UserApi
  public chain: ChainApi
  public facility: FacilityApi
  public import: ImportApi
  public resident: ResidentApi
  public statistics: StatisticsApi
  public statement: StatementApi
  public comment: CommentApi
  public permissions: PermissionsApi
  public template: TemplateApi
  public collectionFlow: CollectionFlowApi
  public claimFlow: ClaimFlowApi
  public transactions: TransactionsApi
  public payments: PaymentsApi
  public residentPortal: ResidentPortalApi
  public hmo: HmoApi
  public letter: LetterApi
  public todo: TodoApi;
  public utils: UtilsApi;
  public billing: BillingApi;
  public onboarding: OnboardingApi;
  public training: TrainingApi;
  public userHolidayPopup: UserHolidayPopupApi;
  public eligibilityTask: EligibilityTaskApi;
  public v2: V2Api;

  constructor () {
    this.instance = new ApiInstance()
    this.auth = new AuthApi(this.instance)
    this.user = new UserApi(this.instance)
    this.chain = new ChainApi(this.instance)
    this.facility = new FacilityApi(this.instance)
    this.import = new ImportApi(this.instance)
    this.resident = new ResidentApi(this.instance)
    this.statistics = new StatisticsApi(this.instance)
    this.statement = new StatementApi(this.instance)
    this.comment = new CommentApi(this.instance)
    this.permissions = new PermissionsApi(this.instance)
    this.template = new TemplateApi(this.instance)
    this.collectionFlow = new CollectionFlowApi(this.instance)
    this.claimFlow = new ClaimFlowApi(this.instance)
    this.transactions = new TransactionsApi(this.instance)
    this.payments = new PaymentsApi(this.instance)
    this.residentPortal = new ResidentPortalApi(this.instance)
    this.hmo = new HmoApi(this.instance)
    this.letter = new LetterApi(this.instance)
    this.todo = new TodoApi(this.instance)
    this.utils = new UtilsApi(this.instance)
    this.billing = new BillingApi(this.instance)
    this.onboarding = new OnboardingApi(this.instance)
    this.training = new TrainingApi(this.instance)
    this.userHolidayPopup = new UserHolidayPopupApi(this.instance)
    this.eligibilityTask = new EligibilityTaskApi(this.instance)
    this.v2 = new V2Api()

    let isShouldSaveLocal = true
    const urlToken = getSearchOptions(window.location.search).token
    const sessionToken = sessionStorage.getItem('jwt')
    if (!urlToken || sessionToken) {
      isShouldSaveLocal = false
    }
    const token: any = urlToken || sessionToken || localStorage.getItem('jwt')
    if (token) {
      this.setToken(token, isShouldSaveLocal)
    }

    const params = new URLSearchParams(window.location.search)
    if (params.has('token')) {
      params.delete('token')
      window.location.search = params.toString()
    }
  }

  getInstance () {
    return this.instance
  }

  getToken () {
    return this.instance.getToken()
  }

  setToken (token: string, isLocal: boolean) {
    this.instance.setToken(token, isLocal)
  }

  getUser () {
    return this.instance.user
  }

  validateToken () {
    return this.instance.validateToken()
  }

  updateTokenIfNeed () {
    this.instance.updateTokenIfNeed()
  }

  async logout (silent: boolean = false) {
    this.instance.logout(silent)
  }

  async refreshToken () {
    await this.instance.refreshToken()
  }
}

export default new Api()
